export default "__VITE_ASSET__CJ$KGNEf__"